import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import useAxiosPrivate from "hooks/useAxiosPrivate";
import { Button, PageContainer, PremiumCard, LoadingState } from "components/ui";

const IconCheck = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor"
       strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <polyline points="20 6 9 17 4 12" />
  </svg>
);
const IconX = () => (
  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor"
       strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const PaymentSuccess = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");
  const axiosPrivate = useAxiosPrivate();
  const [status, setStatus] = useState("loading");

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    const confirm = async () => {
      try {
        await axiosPrivate.post("/api/payments/confirm", { sessionId });
        setStatus("success");
      } catch (_) {
        setStatus("error");
      }
    };
    confirm();
  }, [sessionId]);

  if (status === "loading") {
    return (
      <PageContainer>
        <PremiumCard>
          <LoadingState label="Verifying your payment…" />
        </PremiumCard>
      </PageContainer>
    );
  }

  const success = status === "success";

  return (
    <PageContainer narrow>
      <PremiumCard>
        <div style={{ textAlign: "center", padding: "32px 8px" }}>
          <div
            aria-hidden="true"
            style={{
              width: 80, height: 80, borderRadius: 20,
              background: success
                ? "linear-gradient(135deg, var(--success-bg), #D1FAE5)"
                : "linear-gradient(135deg, var(--danger-bg), #FFE4E6)",
              color: success ? "var(--success)" : "var(--danger)",
              display: "inline-flex", alignItems: "center", justifyContent: "center",
              margin: "0 auto 24px",
              boxShadow: success
                ? "0 8px 24px rgba(16,185,129,0.18)"
                : "0 8px 24px rgba(220,38,38,0.18)",
            }}
          >
            {success ? <IconCheck /> : <IconX />}
          </div>

          <h2 className="t-heading-lg" style={{ margin: 0 }}>
            {success ? "Payment successful" : "Activation failed"}
          </h2>
          <p className="t-body-sm t-muted" style={{ marginTop: 10, marginBottom: 28, maxWidth: 420, marginInline: "auto" }}>
            {success
              ? "Your subscription has been activated. You can now access every premium feature on StockPos."
              : "We couldn't verify your payment. Please try again, or contact support if the charge already went through."}
          </p>
          <Button variant="primary" onClick={() => navigate("/tenant/dashboard")}>
            Go to dashboard
          </Button>
        </div>
      </PremiumCard>
    </PageContainer>
  );
};

export default PaymentSuccess;
